<template>
  <q-btn-dropdown v-if="userNetworksList.length" class="tw-affaire-selector" :class="{ 'is-mini': mini }" flat no-caps
    dropdown-icon="expand_more" content-class="tw-affaire-menu">
    <template #label>
      <q-icon class="tw-affaire-icon" name="bookmark" size="18px" />
      <span class="tw-affaire-body">
        <span class="tw-affaire-title">{{ $t("main.menu.activeBusiness") }}</span>
        <span class="tw-affaire-value">{{ userNetworksLabel }}</span>
      </span>
      <!-- Menu replie : le libelle n'est plus visible, l'infobulle le restitue -->
      <q-tooltip v-if="mini" anchor="center right" self="center left" :offset="[8, 0]" class="tw-side-nav-tooltip">
        {{ $t("main.menu.activeBusiness") }} : {{ userNetworksLabel }}
      </q-tooltip>
    </template>

    <q-list>
      <q-item v-for="item in userNetworksList" :key="item.value" clickable v-close-popup
        @click="onSelectUserNetwork(item)">
        <q-item-section>
          <q-item-label>{{ $t(`main.networkNode.${item.label}`) }}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import i18n from "@/i18n";
import router from "@/router";

/**
 * Selecteur d'affaire active.
 *
 * Deplace du header vers le bas du menu lateral : l'affaire est un contexte de
 * navigation, pas un outil de barre d'application. Le rafraichissement des
 * notifications reste pilote par le header, qui observe deja
 * `authModule.selectedUserNetwork`.
 */
@Options({
  name: "BusinessSelector",
  props: {
    /** Menu replie : seule l'icone est affichee, le libelle passe en infobulle. */
    mini: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "$store.state.authModule.selectedUserNetwork"(newValue: any) {
      if (newValue?.label) {
        this.userNetworksLabel = i18n.global.t(`main.networkNode.${newValue.label}`);
      }
    },
  },
})
export default class BusinessSelector extends Vue {
  mini!: boolean;
  userNetworksLabel: any = "";
  associatedPartyUser = "";

  get userNetworksList() {
    return store?.state?.authModule?.userNetworksList || [];
  }

  created() {
    store.dispatch("orderModule/fetchUser").then((party) => {
      this.associatedPartyUser = party?.resourceUid;
      store.dispatch("authModule/userNetworks", {
        callback: this.updateUserNetworksLabel,
        filter: { user: this.associatedPartyUser },
      });
    });
  }

  /**
   * Retient l'affaire a afficher parmi celles autorisees : sur une fiche
   * dossier c'est celle du dossier, sinon celle memorisee localement.
   */
  updateUserNetworksLabel(response: any) {
    if (response && response[0] && response[0].label) {
      const entityId = store.getters["authModule/getSelectedUserNetwork"];
      if ((this.$route.params.id || store.state.orderModule.order.resourceUid) && entityId) {
        response = [entityId];
      } else {
        const networkFromLocalStorage = store.getters["authModule/getSelectedUserNetworkFromLocalStorage"];
        if (networkFromLocalStorage) {
          response = response?.filter((item: any) => item && item.value === networkFromLocalStorage);
        }
      }
      this.userNetworksLabel = i18n.global.t(`main.networkNode.${response[0].label}`);
      store.dispatch("authModule/setSelectedUserNetwork", { network: response[0] });
    }
  }

  async onSelectUserNetwork(network: any) {
    if (network && network.label) {
      store.dispatch("authModule/setSelectedUserNetwork", { network });
      this.userNetworksLabel = i18n.global.t(`main.networkNode.${network.label}`);
      await router.push("/order");
    }
  }
}
</script>

<!-- Styles du menu lateral : centralises dans src/css/_theme.scss -->
